var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhastpay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 55,
    viewBox: "0 0 149 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_313_3117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.85 23.3892L102.897 20.2617H98.5806L96.0273 23.3892H103.85Z",
    fill: "#00529C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7461 23.9297L102.685 34.3388H107.17L104.042 24.0445L99.7461 23.9297Z",
    fill: "#00529C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6663 23.8203L87.0742 34.3375H91.4513L99.7327 23.9284L95.6663 23.8203Z",
    fill: "#00529C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6791 23.3959L73.4897 20.2617H69.6192L68.8086 23.3959H72.6791Z",
    fill: "#00529C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.967 23.3959L87.7709 20.2617H83.9004L83.0898 23.3959H86.967Z",
    fill: "#00529C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9304 24.0043L82.4643 25.8214H72.0417L72.5821 23.7341L68.7386 23.6328L67.901 26.8684H67.9145L65.9961 34.3459H69.8666L71.2446 28.9623H81.6538L80.2758 34.3459H84.1463L86.7739 24.1056L82.9304 24.0043Z",
    fill: "#00529C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3249 23.3892C65.5275 20.7143 63.3389 20.2617 61.1504 20.2617H48.8432L48.0664 23.3892H65.3249Z",
    fill: "#00529C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.202 24.0039C61.2358 24.166 61.2358 24.3551 61.175 24.6118C60.8643 25.8142 59.9524 25.8007 59.3647 25.8007H51.367V25.7939H47.4493L45.2539 34.3387H49.138L50.5294 28.9214H58.9257C60.7967 28.9214 64.012 28.8809 65.1401 24.4902C65.1738 24.3551 65.1941 24.2268 65.2211 24.0985L61.202 24.0039Z",
    fill: "#00529C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.317 23.3892L129.12 20.2617H116.746C115.023 20.2617 113.044 21.5857 112.051 23.3892H128.317Z",
    fill: "#00529C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.8 25.9813L116.026 25.9745C115.398 25.934 115.033 25.4341 115.215 24.7114C115.323 24.2858 115.58 23.9886 115.857 23.786L111.879 23.6914C111.743 23.9819 111.629 24.2858 111.548 24.5898C110.669 27.9942 113.365 29.0547 114.56 29.0547H123.254C124.186 29.0547 124.22 29.8383 124.138 30.1422C123.97 30.811 123.348 31.2838 122.781 31.2838H110.163L109.379 34.3302H122.524C125.564 34.3302 127.313 31.6013 127.637 30.3516C128.259 27.9604 127.09 25.9813 124.8 25.9813Z",
    fill: "#00529C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.173 23.3881L148.977 20.2539H131.894L131.09 23.3881H148.173Z",
    fill: "#00529C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.957 23.8359L135.262 34.3396H139.139L141.814 23.9305L137.957 23.8359Z",
    fill: "#00529C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.411 34.3398L99.2293 26.207L93.0352 34.3398H101.411Z",
    fill: "#F9951D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3587 31.5612L18.954 31.9935L13.0638 33.0473C10.9766 33.439 9.95654 30.3386 11.1995 27.4138C11.213 27.3867 11.2265 27.3597 11.24 27.3395L22.8717 6.02132C22.6488 6.01456 22.4259 6.00781 22.203 6.00781C10.4767 6.00781 0.972656 15.5118 0.972656 27.2381C0.972656 37.8567 8.76769 46.6514 18.9405 48.2185L22.176 33.1081C22.3584 32.2569 21.9396 31.4599 21.3587 31.5612Z",
    fill: "#00529C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.78 6.07654V5.84013V0.253906L25.5169 5.84013L22.0584 19.7077C21.8558 20.525 22.2543 21.3221 22.815 21.2208L30.1304 19.8496C32.2311 19.4578 33.2511 22.5853 31.9812 25.5236L21.3086 48.0171C21.6058 48.0306 21.9031 48.0373 22.207 48.0373C33.9334 48.0373 43.4373 38.5333 43.4373 26.807C43.4238 16.6545 36.3043 8.17053 26.78 6.07654Z",
    fill: "#F9951D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4536 28.1045C40.2721 26.6522 36.4692 25.5309 32.2744 24.8555C32.2069 25.0514 32.1326 25.254 32.0515 25.4499L21.3789 47.9434C21.6762 47.9569 21.9734 47.9636 22.2773 47.9636C33.5308 47.9636 42.7444 39.1891 43.4536 28.1045Z",
    fill: "#CF7C18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.327 31.5948L18.9223 32.0271L13.0321 33.0808C10.9448 33.4726 9.92488 30.3722 11.1678 27.4473C11.1813 27.4203 11.1948 27.3933 11.2083 27.373L12.4985 25.0156C8.10784 25.8059 4.1833 27.0826 0.988281 28.7105C1.61648 38.0997 8.34426 45.8136 17.2404 47.9279L17.7672 53.3452L18.8413 48.2454C18.8615 48.2454 18.8818 48.2521 18.902 48.2589L22.1376 33.1484C22.3267 32.2905 21.9079 31.4935 21.327 31.5948Z",
    fill: "#004482"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_313_3117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 54,
    fill: "white",
    transform: "translate(0.972656 0.253906)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhastpay);
export default __webpack_public_path__ + "static/media/phastpay.064404d304a8d590da25625aaa99eb22.svg";
export { ForwardRef as ReactComponent };